export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');
        console.log('Service Worker registered:', registration);

        // Check version after registration
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage('CHECK_VERSION');
        }

        registration.onupdatefound = () => {
          const newWorker = registration.installing;
          newWorker.onstatechange = () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('New build detected!');
              navigator.serviceWorker.controller.postMessage('CHECK_VERSION');
            }
          };
        };

         //  When user returns to tab
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible' && navigator.serviceWorker.controller) {
            console.log('Tab focused — checking for new build...');
            navigator.serviceWorker.controller.postMessage('CHECK_VERSION');
          }
        });

        //  When network is back online
        window.addEventListener('online', () => {
          if (navigator.serviceWorker.controller) {
            console.log(' Back online — checking for new build...');
            navigator.serviceWorker.controller.postMessage('CHECK_VERSION');
          }
        });

      } catch (error) {
        console.error('Service Worker registration failed:', error);
      }
    });
  }
}
